<template>
  <div v-if="show && ready">
    <div class="card">
      <div class="card-header">
        <div class="d-flex align-items-center justify-content-between">
          <h1>Clientes</h1>
          <div class="switch-container">
            <span class="switch-label mr-1">Status</span>
            <toggle-button
              class="mb-0 mr-3"
              v-model="form.status"
              :width="80"
              :height="25"
              :labels="{ checked: 'ATIVO', unchecked: 'INATIVO'}"
            />
          </div>
        </div>
      </div>
      <div class="card-body">
        <b-alert
          show
          dismissible
          variant="info"
          class="mt-0"
          v-if="instance.id"
        >É possível alterar apenas a senha, qualquer outro tipo de alteração deve ser feito via CRM</b-alert>

        <div class="row">
          <b-form-group class="col-12 col-md-4" label="Nome Completo*" label-for="name" description>
            <b-form-input
              id="name"
              type="text"
              :disabled="true"
              v-model="form.name"
              required
              placeholder="Nome Completo do Usuário"
              :class="{
                'is-invalid': submitted && form.errors.has('name')
              }"
            ></b-form-input>
          </b-form-group>

          <div class="col-12 col-md-6 form-group">
            <label for="email">
              E-mail
              <!--<span class="text-muted">(Mesmo e-mail do LDAP)</span>-->
            </label>
            <b-form-input
              id="email"
              type="text"
              :disabled="!emptyInstance"
              required
              v-model="form.email"
              placeholder="E-mail do Usuário"
              :class="{
                'is-invalid': submitted && form.errors.has('email')
              }"
            ></b-form-input>
          </div>

          <div class="col-12 text-right changePassword" v-show="instance.id">
            <a href="#" @click.prevent.stop="togglePassword">
              <small>{{ updatePassword ? 'Ocultar' : 'Alterar Senha' }}</small>
            </a>
          </div>
          <template v-if="updatePassword">
            <b-form-group
              class="col-12 col-md-6"
              label="Senha"
              label-for="password"
              :description="instance.id ? 'Apenas preencha os campos de senha se você quiser atualiza-la' : ''"
            >
              <b-form-input
                id="password"
                type="password"
                v-model="form.password"
                placeholder="******"
                :class="{
                'is-invalid': submitted && form.errors.has('password'),
                'is-valid': submitted && !form.errors.has('password')
              }"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              class="col-12 col-md-6"
              label="Confirmação da Senha"
              label-for="password_confirmation"
              description
            >
              <b-form-input
                id="password_confirmation"
                type="password"
                v-model="form.password_confirmation"
                placeholder="******"
                :class="{
                'is-invalid': submitted && form.errors.has('password'),
                'is-valid': submitted && !form.errors.has('password')
              }"
              ></b-form-input>
            </b-form-group>
          </template>
        </div>
      </div>
    </div>

    <div v-if="show && ready && form.detail">
      <div class="card">
        <div class="card-header">
          <div class="d-flex align-items-center justify-content-between">
            <h1>Detalhes - {{ form.detail.entity_type_label }}</h1>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <b-form-group
              class="col-12 col-md-4"
              label="Referência Externa (CRM)"
              label-for="external_reference"
              description
            >
              <b-form-input
                id="external_reference"
                type="text"
                :disabled="true"
                v-model="form.detail.external_reference"
                required
                placeholder="XXXXXXX99"
                :class="{
                  'is-invalid': submitted && form.errors.has('detail.external_reference')
                }"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              class="col-12 col-md-4"
              label="Documento"
              label-for="document"
              description
            >
              <b-form-input
                id="document"
                type="text"
                :disabled="true"
                v-model="form.detail.document"
                required
                placeholder="99999999999"
                :class="{
                  'is-invalid': submitted && form.errors.has('detail.document')
                }"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              class="col-12 col-md-4"
              label="Documento Complementar"
              label-for="complementary_document"
              description
            >
              <b-form-input
                id="complementary_document"
                type="text"
                :disabled="true"
                v-model="form.detail.complementary_document"
                required
                placeholder="99999999999"
                :class="{
                  'is-invalid': submitted && form.errors.has('detail.complementary_document')
                }"
              ></b-form-input>
            </b-form-group>
          </div>

          <!-- <div class="row" v-if="form.detail.entity_type_abbreviation === 'PJ'">
            <b-form-group
              class="col-12 col-md-12"
              label="URL do Contrato"
              label-for="contract_url"
              description
            >
              <b-form-input
                id="contract_url"
                type="text"
                :disabled="true"
                v-model="form.detail.contract_url"
                required
                placeholder="https://url.br/contract.pdf"
                :class="{
                  'is-invalid': submitted && form.errors.has('detail.contract_url')
                }"
              ></b-form-input>
            </b-form-group>
          </div> -->

          <div class="row">
            <b-form-group
              class="col-12 col-md-4"
              label="Contato"
              label-for="contact_name"
              description
            >
              <b-form-input
                id="contact_name"
                type="text"
                :disabled="true"
                v-model="form.detail.contact_name"
                required
                placeholder="John Doe"
                :class="{
                  'is-invalid': submitted && form.errors.has('detail.contact_name')
                }"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              class="col-12 col-md-4"
              label="Número de Telefone"
              label-for="phone_number"
              description
            >
              <b-form-input
                id="phone_number"
                type="text"
                :disabled="true"
                v-model="form.detail.phone_number"
                required
                placeholder="99999999999"
                :class="{
                  'is-invalid': submitted && form.errors.has('detail.phone_number')
                }"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              class="col-12 col-md-4"
              label="Número de Telefone Alternativo"
              label-for="phone_number_alt"
              description
            >
              <b-form-input
                id="phone_number_alt"
                type="text"
                :disabled="true"
                v-model="form.detail.phone_number_alt"
                required
                placeholder="99999999999"
                :class="{
                  'is-invalid': submitted && form.errors.has('detail.phone_number_alt')
                }"
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="row">
            <div class="col-12 col-md-12 form-group">
              <label for="detail.date_of_birth">Dia do Aniversário</label>
              <datepicker
                :form="form"
                :class="{'is-invalid': form.errors.has('detail.date_of_birth')}"
                field="detail.date_of_birth"
                :disabled="true"
              ></datepicker>
            </div>
          </div>

          <div class="row" v-if="form.detail.entity_type_abbreviation === 'PJ' && form.detail.contract_url">
            <b-form-group
              class="col-12 col-md-12"
              label="URL do Contrato"
              label-for="contract_url"
              description
            >
              <b-link href="form.detail.contract_url" target="_blank">{{ form.detail.contract_url }}</b-link>
            </b-form-group>
          </div>
        </div>
      </div>
    </div>

    <!-- BITRIX -->
    <div v-if="show && ready && (form.bitrix_contact.length >= 1)">
      <div class="card">
        <div class="card-header">
          <div class="d-flex align-items-center justify-content-between">
            <h1>Integração CRM</h1>
          </div>
        </div>
        <div class="card-body">

          <div v-for="item in form.bitrix_contact" v-bind:key="item.id">
            <div class="row">

              <b-form-group class="col-12 col-md-3" label="Referência Externa (CRM)">
                <b-form-input type="text" :disabled="true" v-model="item.external_reference"></b-form-input>
              </b-form-group>

              <b-form-group class="col-12 col-md-3" label="Situação">
                <b-form-input type="text" :disabled="true" v-model="item.situation"></b-form-input>
              </b-form-group>

              <b-form-group class="col-12 col-md-3" label="Código de Retorno">
                <b-form-input type="text" :disabled="true" v-model="item.code"></b-form-input>
              </b-form-group>

              <b-form-group class="col-12 col-md-3" label="Local">
                <b-form-input type="text" :disabled="true" v-model="item.status_obj.local"></b-form-input>
              </b-form-group>

            </div>

            <div class="row">

              <b-form-group class="col-12 col-md-12" label="Mensagem">
                <b-form-input type="text" :disabled="true" v-model="item.status_obj.mensagem"></b-form-input>
              </b-form-group>

            </div>

            <hr/>
          </div>

        </div>
      </div>
    </div>
    <!-- BITRIX -->

    <div class="card" v-if="show && ready && form.address">
      <div class="card-header">
        <h1>Localização</h1>
      </div>
      <div class="card-body">
        <address-fields :form="form" :disabled="true"></address-fields>
      </div>
    </div>

    <div v-if="instance.id" class="card">
      <div class="card-header">
        <h1>Dados de acesso</h1>
      </div>
      <div class="card-body">
        <dl class="row mb-0">
          <dt class="col-sm-2">Cadastrado em</dt>
          <dd class="col-sm-10">{{ instance.created_at | moment('DD/MM/YYYY HH:MM') }}</dd>

          <dt class="col-sm-2">Último acesso</dt>
          <dd class="col-sm-10">
            <span
              v-if="instance.last_login"
            >{{ instance.last_login.date | moment('DD/MM/YYYY HH:MM') }}</span>
            <span v-else>Nenhum acesso foi registrado</span>
          </dd>

          <dt class="col-sm-2">Total de acessos</dt>
          <dd class="col-sm-10">{{ instance.days_logged || 'Nenhum acesso foi registrado' }}</dd>
        </dl>
      </div>
    </div>
    <div class="card-footer text-right">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import Datepicker from '@/components/ui/Datepicker.vue'
import { mapActions, mapGetters } from 'vuex'
import { get, set, merge, clone, isArray, isObject } from 'lodash'

export default {
  components: {
    datepicker: Datepicker
  },
  props: {
    form: {
      type: [Object],
      required: true
    },

    submitted: {
      type: Boolean,
      default: false
    },

    instance: {
      type: Object,
      default () {
        return {
          roles: [{}],
          avatar: []
        }
      }
    },

    http: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      show: true,
      updatePassword: false,
      locks: {
        categories: true
      },
      empty: {
        status: true,
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        role: 'user',
        roles: [1],
        address: {
          address: '',
          number: '',
          city_id: null,
          neighborhood: '',
          complement: '',
          zipcode: '',
          maps: ''
        },
        detail: {
          external_reference: '',
          entity_type: '',
          document: '',
          complementary_document: '',
          contract_url: '',
          contact_name: '',
          phone_number: '',
          phone_number_alt: '',
          date_of_birth: ''
        }
      },
      roles: []
    }
  },

  watch: {
    $props: {
      handler: function (newProps, oldProps) {
        if (!get(newProps, 'form.role_id', false)) {
          this.form.role = 'user'
        }
      },
      deep: true
    }
  },

  computed: {
    ready () {
      return !this.locks.roles
    },

    ...mapGetters({
      loggedUser: 'auth/user'
    }),

    emptyInstance () {
      return get(this.instance, 'id', null) === null
    }
  },

  methods: {
    get,

    ...mapActions({
      fetchUser: 'auth/fetchUser'
    }),

    updateForm (path, value, valuePath) {
      set(
        this.form,
        path,
        isObject(value) ? get(value || {}, valuePath || 'id', null) : value
      )
    },

    togglePassword () {
      this.updatePassword = !this.updatePassword

      if (!this.updatePassword) {
        this.form.password = ''
        this.form.password_confirmation = ''
      }
    }
  },

  created () {
    const self = this

    if (self.instance.id) {
      self.form
        .withData(self.instance)
        .setInitialValues(merge(self.empty, self.instance))
    } else {
      self.updatePassword = true
      self.form.withData(clone(self.empty)).setInitialValues(clone(self.empty))
    }

    // Fixes the form for profile
    const profile = get(self.form, 'profile', false)
    if (isArray(profile) || !isObject(profile)) {
      set(self.form, 'profile', {})
    }

    // Fixes the role
    self.form.roles = [1]
    self.form.role_id = 1
    self.form.role = 'user'
  }
}
</script>

<style lang="scss" scoped>
.changePassword {
  margin-bottom: 20px
}
</style>



// WEBPACK FOOTER //
// src/components/forms/System/UserSite.vue